import { render, staticRenderFns } from "./DemandDetails.vue?vue&type=template&id=2da9b334&scoped=true&"
import script from "./DemandDetails.vue?vue&type=script&lang=js&"
export * from "./DemandDetails.vue?vue&type=script&lang=js&"
import style0 from "./DemandDetails.vue?vue&type=style&index=0&id=2da9b334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9b334",
  null
  
)

export default component.exports